import React, {Component, useState, useEffect} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import ContactContent from '../components/ContactContent'; 
import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import withRouter from '../components/withRouter';
import { Helmet } from "react-helmet";
import {  base_url} from '../common/Constants';

class Contact extends React.Component{

    constructor(){
        super();  
    }
 
    render()
    { 
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
       
        return (
           <div className="body-block">
  <div className="page-block contacts">
                <Header/>
                <Helmet>
                    <title>{metas[6].title}</title>  
                    <meta name="description" content={metas[6].meta_description} />
                    <meta name="keywords" content={metas[6].meta_title} />
                    <meta property="og:image" content={base_url+'assets/img/logo.png'}  />
                    <link rel="canonical" href={base_url+'contact'} />
                </Helmet> 
                <PageHeader title="Contact Us" banner={base_url+`assets/_nuxt/img/contact.078a756.jpg`} /> 
                <ContactContent  content={JSON.parse(localStorage.getItem("content"))}  settings={JSON.parse(localStorage.getItem("settings"))}  />  
                <Footer/>
      
        </div>
        </div>
       
        )
    }

}
export default withRouter(Contact);;